<template lang="pug">
//- include login.pug
.login.mfa(v-if="mfa")
  p.title {{ $t('Log In Securely') }}
  p.small {{ mfaOriginText() }}.
  p.small {{ $t('Please enter it below') }}.
  form.form(@submit.prevent='checkMfa' autocomplete="off")
    .row
      ed-input.col-md-7(name='code' hide-optional :field-label='$t("One-time code")' v-model='mfaData.code' autocomplete="off" )
    .text-right
      ed-button.alt(button-class='btn btn-secondary' type='button' @click="cancel" value='cancel') {{ $t('Cancel') }}
      | &nbsp;
      ed-button(button-class='btn btn-primary' type='submit' value='next', :endpoint='loginEndpoint') {{ $t('Next') }}
.login(v-else)
  p.title {{ $t('login.cta') }}
  form.form(@submit.prevent='loginUser')
    ed-input(name='username' hide-optional type='email', :field-label='$t("login.Email")', :placeholder='$t("login.emailHint")' v-model='loginDetails.username')
    ed-input(name='password' hide-optional type='password' show-password, :field-label='$t("login.Password")', :placeholder='$t("login.passwordHint")' v-model='loginDetails.password')
    ed-checkbox(:options='remember')
    .text-right
      .pull-left.login-message
        a(href="#" @click.prevent='forgotPassword') Forgot your password?
      button.btn.btn-primary.float-right-.pull-right-(type='submit' value='login', :endpoint='loginEndpoint') {{ $t('login.button') }}
    .alert.alert-danger(v-if='loginError.message' role='alert')
      span(v-html='$t(loginError.message)')
      //br

  ed-modal.middle(
    :submitEndpoint='api.$.settings.my.resetPassword'
    :show="showForgotPassword"
    @close='showForgotPassword = false'
    @validate='submitForgotPassword'
    title=''
    subtitle='Enter the e-mail address associated with your account to have your password reset.'
    primaryButton='Submit'
    secondaryButton='false'
    type="small"
    validation
  )
    div(slot="body")
      ed-input(type='email' v-model='email', :class='emailValidation')

  ed-modal.middle(
    :submitEndpoint='api.$.settings.my.resetPassword'
    :show="showFeedback"
    @confirm='showFeedback = false'
    @close='showFeedback = false'
    title=''
    :subtitle='feedbackMessage'
    primaryButton='Ok'
    secondaryButton='false'
  )
</template>

<script>
/* eslint no-multi-spaces: 0 */
import loginService from './loginService.js'
const mfaSetup = 'MFA_SETUP'

export default {
  alias: 'login',
  data() {
    return {
      email: '',
      emailValidation: '',
      feedbackMessage: '',

      loginDetails: {
        username: '',
        password: ''
      },

      mfaData: {
        code: '',
        session: '',
        challengeName: '',
        challengeParameters: []
      },

      remember: [{
        status: false,
        label: 'Remember me.'
      }],

      loginError: {
        message: ''
      },

      showFeedback: false,
      showForgotPassword: false,

      loginEndpoint: this.api.$.login,
      mfaOriginText: () => {
        switch (this.mfaData.challengeName) {
          case 'SOFTWARE_TOKEN_MFA': return 'Check your authenticator for the one-time code'
          case 'CUSTOM_CHALLENGE': return 'We sent you a one-time code to your email'
          default : return 'We sent you a one-time code to your phone number'
        }
      },
      validEmail: email => {
        var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i // eslint-disable-line
        return re.test(email)
      }
    }
  },

  computed: {
    mfa() {
      return typeof this.$route.query.mfa !== 'undefined'
    }
  },

  methods: {
    /**
     * Authenticates user on PHP endpoint
     * then init user in app
     */
    loginUser() {
      return loginService.login.call(this, this.loginDetails)
        .then(res  => { !res.ChallengeName ? loginService.init.call(this, {...res, sk: res.error ? null : res.sk}) : this.handleMfa(res) })
        .catch(err => { loginService.handle(err) })
    },

    /**
     * Displays MFA screen
     */
    handleMfa(data) {
      if (data.ChallengeName === mfaSetup) {
        loginService.init.call(this, data, false)
        this.$router.push('/mfa-setup')
      } else {
        this.mfaData.session = data.Session
        this.mfaData.challengeName = data.ChallengeName
        this.mfaData.challengeParameters = data.ChallengeParameters
        this.$router.push({
          name: 'login',
          query: {
            mfa: null,
            ...this.$route.query
          }
        })
      }
    },

    /**
     * Resends MFA code
     */
    resendMfaCode() {
      // TODO
      this.api.post(`${this.api.$.login}?mfaCodeResend`)
    },

    /**
     * Checks MFA
     * then proceed to authentication
     * */
    checkMfa() {
      this.mfaData.code = this.mfaData.code.trim()
      this.api.post(`${this.api.$.mfa.validateCode}`, this.mfaData)
        .then(resp  => { resp.data.error ? this.handleBadCode(resp) : loginService.init.call(this, {...resp.data, sk: resp.data.error ? null : resp.data.sk}) })
        .catch(err => { loginService.handle(err) })
    },

    /**
     * Check user authorization on landing in login
     * then redirect acordingly
     */
    loginAuth() {
      loginService.auth.call(this)
    },

    /**
     * Autologin
     * with sk
     */
    autoLogin(sk) {
      loginService.autoLogin.call(this, sk)
        .then(res  => { loginService.init.call(this, res) })
        .catch(err => { loginService.handle(err) })
    },

    /**
     * Forgot password
     */
    forgotPassword() {
      this.showForgotPassword = true
      this.emailValidation = ''
    },

    /**
     * Send email for resetting password
     */
    submitForgotPassword() {
      if (this.validEmail(this.email)) {
        this.emailValidation = ''

        // call endpoint
        this.api.forms.post(this.api.$.settings.my.resetPassword, {
          email: this.email
        }).then(res => {
          res && res.data && this.passwordResetFeedback(res.data)
        })
        //
      } else {
        this.emailValidation = 'has-error'
      }
    },

    handleBadCode(r) {
      if (r.data.session !== this.mfaData.session) {
        this.mfaData.session = r.data.session
      }
      global.alert(r.data.error || 'Something went wrong')
    },

    passwordResetFeedback(message) {
      this.email = ''
      this.feedbackMessage = message
      this.showForgotPassword = false
      this.showFeedback = true
    },

    cancel() {
      this.$router.push('/login')
    }
  },

  created() {
    this.$route.query.sk
      ? this.autoLogin(this.$route.query.sk)
      : this.loginAuth()
  }
}
</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";
//@import "login.scss";

.theme.public .login.module {
  .form-group .form-check-label {
    //font-size: $font-size-base;
  }
}

.login .title {
  font-weight: $font-weight-extra-bold;
  margin-bottom: 1rem;
}
.login .navbar .navbar-brand.logo {
  img { display: inline; }
}

.login-message {
  font-size: $font-size-base;
  line-height: 4.5em;
}

.login .resend-code {
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/Login/index.vue